import React from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import { TimePicker } from '../time-picker';
import styles from './time-field.st.scss';
import { isTimeFieldElement } from '../time-picker/helpers';
// ToDo: Styling according to the new designs

export function TimeField(_ref) {
  let {
    use24HourFormat = false,
    onBlur,
    onChange,
    onFocus,
    inputId,
    ariaLabelledBy,
    value,
    id,
    disabled,
    error,
    hidePlaceholder,
    required,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const handleBlur = event => {
    if (!isTimeFieldElement(event.relatedTarget)) {
      onBlur == null || onBlur(event);
    }
  };
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: handleBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy
  }, /*#__PURE__*/React.createElement(TimePicker, {
    disabled: disabled,
    error: error,
    hidePlaceholder: hidePlaceholder,
    required: required,
    className: styles.time,
    "data-hook": id,
    use24Hours: use24HourFormat,
    onChange: onChange,
    value: value
  }));
}
TimeField.displayName = 'TimeField';
//# sourceMappingURL=time-field.js.map